// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import update from "immutability-helper";

import type { StateType, DispatchType } from "../../../global/types/redux";
import type { ErrorsType } from "../../../account/types/UserFormType";
import {
  ErrosDisplay,
  setErrorMsg
} from "../../../account/containers/ErrosDisplay";
import { StyledTextField, CancelButton, SubmitButton } from "imagus-components";
import { propComparator } from "../../../global/functions/StringOperations";
import { CompileDatabaseItemtoJsItem } from "../../../account/components/quotes/QuoteCompileFunctions";
import {
  createProductSheet,
  updateProductSheet
} from "../../actions/quoteAdminActions";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

type CreateQuoteFormPropsType = {
  actions: { [key: string]: Function },
  priceSheet: { [key: string]: * },
  onClose: Function,
  productSheet?: { [key: string]: * }
};

type RangeType = {
  price: number,
  minimum: number
};

type PartType = {
  licenceType: string,
  partNo: string,
  description: string,
  price: number,
  minimum: number,
  maximum: number,
  ranges?: Array<RangeType>
};

type CreateQuoteFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  description: string,
  parts: Array<PartType>
};

class CreateProductSheetForm extends Component<
  CreateQuoteFormPropsType,
  CreateQuoteFormStatesType
> {
  constructor(props: CreateQuoteFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      errors: {},
      loading: false,
      description: "",
      parts: []
    };
  }

  componentDidMount() {
    let parts = [];
    const priceSheet =
      this.props.priceSheet && this.props.priceSheet.parts.edges;
    priceSheet.sort(
      propComparator("node", false, "licenceType", null, false, "orderId")
    );

    priceSheet.map(
      (part: *, i: number): * => {
        let sheetPart;
        const productSheet = this.props.productSheet;
        if (productSheet) {
          let index =
            productSheet.sheetParts.edges &&
            productSheet.sheetParts.edges.findIndex(
              item => item.node.part.partNo === part.node.partNo
            );
          if (index > -1) {
            sheetPart = productSheet.sheetParts.edges[index].node;
          }
        }

        let item = CompileDatabaseItemtoJsItem(part.node, sheetPart);

        let ranges = [];
        item.priceRanges.map(
          (range: *): * => {
            ranges.push({
              price: range.node.price,
              minimum: range.node.minimumQuantity
            });
          }
        );

        parts.push({
          licenceType: item.licenceType,
          partNo: item.partno,
          description: item.desctiotion,
          price: item.price,
          minimum: item.min,
          maximum: item.max,
          ranges: item.hasRange ? ranges : []
        });
      }
    );

    this.setState({
      parts: parts,
      description: this.props.productSheet
        ? this.props.productSheet.description
        : ""
    });
  }

  handleTextChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value
    });
  };

  handleQtyChange = (id: number, field: string): * => (
    e: SyntheticInputEvent<*>
  ): * => {
    const value = e.target.value;
    const parts = update(this.state.parts, {
      [id]: { [field]: { $set: value } }
    });
    this.setState({
      parts: parts
    });
  };

  handleRangeChange = (id: number, rid: number, field: string): * => (
    e: SyntheticInputEvent<*>
  ): * => {
    const value = e.target.value;
    const parts = update(this.state.parts, {
      [id]: { ranges: { [rid]: { [field]: { $set: value } } } }
    });
    this.setState({
      parts: parts
    });
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((): * => ({ loading: true }));

    if (this.props.productSheet) {
      this.props.actions.updateProductSheet(
        this.props.productSheet.id,
        this.state.description,
        this.state.parts,
        this.submitDone,
        this.submitFail
      );
    } else {
      this.props.actions.createProductSheet(
        this.state.description,
        this.state.parts,
        this.submitDone,
        this.submitFail
      );
    }
  };

  submitDone = () => {
    this.props.onClose();
  };

  submitFail = (errors: ErrorsType) => {
    this.setState({ errors: errors, loading: false });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;

    return (
      <form
        onSubmit={(!loading && this.submit) || undefined}
        className="app-wrapper"
      >
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <Grid item xs={6}>
                <StyledTextField
                  isRequired={true}
                  label="New Product Sheet Description"
                  name="description"
                  value={this.state.description ? this.state.description : ""}
                  onChange={this.handleTextChange}
                  inpuType="text"
                />
              </Grid>
              <Grid item xs={12}>
                <Paper>
                  <Table className="app-table green center">
                    <TableHead>
                      <TableRow className="active">
                        <TableCell className="blue-shine" padding="dense">
                          Licence Type
                        </TableCell>
                        <TableCell className="blue-shine" padding="dense">
                          Part No.
                        </TableCell>
                        <TableCell className="blue-shine" padding="dense">
                          Description
                        </TableCell>
                        <TableCell className="blue-shine" padding="dense">
                          Base Price(AUD) *
                        </TableCell>
                        <TableCell className="blue-shine" padding="dense">
                          Minimum Quantity *
                        </TableCell>
                        <TableCell className="blue-shine" padding="dense">
                          Maximum Quantity
                        </TableCell>
                        <TableCell className="blue-shine" padding="dense">
                          Price Ranges
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.parts.map(
                        (part: PartType, i: number): * => (
                          <TableRow key={"part" + i}>
                            <TableCell padding="dense">
                              {part.licenceType}
                            </TableCell>
                            <TableCell padding="dense">{part.partNo}</TableCell>
                            <TableCell padding="dense">
                              {part.description}
                            </TableCell>
                            <TableCell padding="dense">
                              <StyledTextField
                                isRequired={true}
                                name={"part" + i + "price"}
                                value={part.price !== null ? part.price : ""}
                                onChange={this.handleQtyChange(i, "price")}
                                inpuType="number"
                                label=""
                              />
                            </TableCell>
                            <TableCell padding="dense">
                              <StyledTextField
                                isRequired={true}
                                name={"part" + i + "minimum"}
                                value={
                                  part.minimum !== null ? part.minimum : ""
                                }
                                onChange={this.handleQtyChange(i, "minimum")}
                                inpuType="number"
                                label=""
                              />
                            </TableCell>
                            <TableCell padding="dense">
                              <StyledTextField
                                isRequired={false}
                                name={"part" + i + "maximum"}
                                value={
                                  part.maximum !== null ? part.maximum : ""
                                }
                                onChange={this.handleQtyChange(i, "maximum")}
                                inpuType="number"
                                label=""
                              />
                            </TableCell>
                            <TableCell padding="dense">
                              {part.ranges &&
                                part.ranges.map(
                                  (range: *, j: number): * => (
                                    <Grid
                                      container
                                      spacing={8}
                                      key={i + "range" + j}
                                    >
                                      <Grid item xs={6}>
                                        <StyledTextField
                                          isRequired={true}
                                          name={
                                            "part" + i + "ranges" + j + "price"
                                          }
                                          value={
                                            range.price !== null
                                              ? range.price
                                              : ""
                                          }
                                          onChange={this.handleRangeChange(
                                            i,
                                            j,
                                            "price"
                                          )}
                                          inpuType="number"
                                          label="Range Price(AUD)"
                                        />
                                      </Grid>
                                      <Grid item xs={6}>
                                        <StyledTextField
                                          isRequired={true}
                                          name={
                                            "part" +
                                            i +
                                            "ranges" +
                                            j +
                                            "minimum"
                                          }
                                          value={
                                            range.minimum !== null
                                              ? range.minimum
                                              : ""
                                          }
                                          onChange={this.handleRangeChange(
                                            i,
                                            j,
                                            "minimum"
                                          )}
                                          inpuType="number"
                                          label="Threshold(when >=)"
                                        />
                                      </Grid>
                                    </Grid>
                                  )
                                )}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <ErrosDisplay errors={errors} form="create quote" />
              </Grid>
              <Grid item xs={12}>
                <div className="form-right-btn-block">
                  <CancelButton onClick={this.props.onClose} />
                  <SubmitButton
                    loading={loading}
                    title="Save"
                    disabled={Object.keys(errors).length > 0}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  priceSheet: state.v3account.quote.priceSheet
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { createProductSheet, updateProductSheet },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateProductSheetForm);
